import { render } from "preact";
import Markup from "preact-markup";
import { create } from 'jss';
import jssGlobal from 'jss-plugin-global';
import jssVendorPrefixer from 'jss-plugin-vendor-prefixer';

import { ws } from "./client";
import { Button } from "./components";

const jss = create();


jss.use(jssGlobal(), jssVendorPrefixer());
var sheet = jss.createStyleSheet({}, { link: true }).attach();


function onSchemaError(error) {
    console.log(error);
}

function onMarkupError(error) {
    console.log(error);
}

function onCssError(error) {
    console.log(error);
}


ws.addEventListener('message', ev => {
    console.log(ev.data);
    try {
        var json = JSON.parse(ev.data);
    } catch (SyntaxError) {
        onSchemaError("could not parse JSON.");
        return;
    }
    console.log(json);
    if (!("event" in json)){
        onSchemaError("no event key found");
        return;
    }
    if (!("data" in json)) {
        onSchemaError("no data key found");
        return;
    }
    var data = json["data"];
    var event = json["event"];
    switch(event) {
        case "htmlupdate": {
            console.log("htmlupdate");
            const parent = 'parent' in json ? json.parent : null;
            htmlupdate(data, parent);
        }; break;
        case "cssupdate": {
            console.log("cssupdate");
            cssupdate(data);
        }; break;
        case "cssoverwrite": {
            console.log("cssoverwrite");
            const media = 'media' in json ? json.media : null;
            cssoverwrite(data, media);
        }; break;
    }
});


function htmlupdate(new_html, parent) {
    try {
        _unsafe_htmlupdate(new_html, parent);
    } catch (error) {
        onMarkupError(error);
    }
}

function _unsafe_htmlupdate(new_html, parent) {
    parent = parent
        ? document.getElementById(parent)
        : document.getElementById("app");
    if (parent === null) {
        throw "parent does not exist";
        return;
    }

    const components = { Button };
    const markup_component = (
        <Markup
            type="html"
            markup={new_html}
            components={components}
            wrap={false}
            onError={(error) => onMarkupError(error)}
            allow-scripts
            allow-events
        />
    );
    render(markup_component, parent);
}

function cssoverwrite(css, media) {
    try {
        _unsafe_cssoverwrite(css, media);
    } catch (error) {
        onCssError(error);
    }
}

function cssupdate(css) {
    try {
        _unsafe_cssupdate(css);
    } catch (error) {
        onCssError(error);
    }
}

function _unsafe_cssoverwrite(css, media) {
    css = { "@global": css };
    jss.removeStyleSheet(sheet);
    sheet = jss.createStyleSheet(css, { media: media, link: true }).attach();
}

function _unsafe_cssupdate(css) {
    const apply_rule = (parent_rule, css) => {
        // console.log("parent_rule");
        // console.log(parent_rule);
        for (const selector in css) {
            // console.log("selector: " + selector);
            const rule = parent_rule.rules.index.find(rule => rule.key === selector);
            // console.log("rule: " + rule);
            if (rule === undefined) {
                // console.log("addRule: " + selector + ": " + css[selector]);
                sheet.addRule(selector, css[selector]);
            } else {
                for (const prop in css[selector]) {
                    // console.log(css[selector][prop]);
                    if (typeof css[selector][prop] === 'object') {
                        // console.log("object: " + prop);
                        apply_rule(rule, { [prop]: css[selector][prop] });
                        continue;
                    }
                    // console.log("prop: " + prop + ": " + css[selector][prop]);
                    // console.log(rule);
                    rule.prop(prop, css[selector][prop]);
                }
            }
        }
        // console.log(sheet);
    };

    const global_rule = sheet.getRule("@global");
    // console.log(global_rule);
    apply_rule(global_rule, css);
}
